import AICatalyst from './AICatalyst'

export default AICatalyst
